import styled from "styled-components";

export default styled.div`
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
  min-height: 450px;
  max-height: 525px;
  padding: 30px 15px;
  background: ${(props) => props.theme.colors.ellipse_4};
  border-radius: 15px;
  color: ${(props) => props.theme.colors.ellipse_20};
  img {
    user-select: none;
  }
  header {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 18px;
    h3 {
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      line-height: 21px;
      text-align: center;
    }
    .bonus-amount {
      color: ${(props) => props.theme.colors.ellipse_34};
      font-weight: 500;
      font-size: 40px;
      line-height: 25px;
      display: flex;
      align-items: center;
      letter-spacing: -0.025em;
    }
  }
  .card-custom-body {
    width: 100%;
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .or {
    text-align: center;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 21px;
    margin-bottom: 5px;
  }
`;

export const NFTCollectionsStyle = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 3px;
  max-width: 380px;
  margin: 1rem 0;
  img {
    border-radius: 5px;
    height: 80px;
    width: 75px;
    object-fit: none;
    filter: drop-shadow(9px 11px 19px rgba(20, 19, 36, 0.31));
  }
`;

export const SelectedNFTStyle = styled.div`
  margin-top: 5px;
  text-align: center;
  :before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 278px;
    background: ${(props) => props.theme.colors.ellipse_30};
    border-radius: 15px 15px 200px 200px;
    pointer-events: none;
    user-select: none;

    @media screen and (max-width: 769px) {
      content: unset;
    }
  }
  .image-container {
    position: relative;
    height: 250px;
    width: 200px;
    margin: 0 auto;
    .nft-image {
      height: 250px;
      width: 200px;
    }
    .rocket-icon {
      background: #38a0ff;
      border-radius: 30px 30px 30px 0px;
      right: -10px;
      top: 35px;
      position: absolute;
      width: 38px;
      height: 38px;
      display: grid;
      place-items: center;
      img {
        width: 25px;
      }
    }
  }
  .selected-nft-info-text {
    margin: 10px 0;
    font-style: normal;
    font-weight: 400;
    font-size: 13px;
    line-height: 20px;
    text-align: center;
    color: ${(props) => props.theme.colors.ellipse_20};
  }

  @media screen and (max-width: 769px) {
    .rocket-icon {
      right: 50% !important;
      transform: translateX(50%) !important;
      bottom: -5px !important;
      top: unset !important;
      background: linear-gradient(
        180deg,
        rgba(24, 196, 176, 0.5) 0%,
        rgba(34, 158, 177, 0.5) 100%
      ) !important;
      backdrop-filter: blur(24px) !important;
    }
  }
`;
